module.exports = __webpack_public_path__ + "static/media/imperative_mood1_img.42819a35.JPG";